<template>
  <div class="content">
    <div class="img_box">
      <div class="img_center">
        <div class="img_text">
          <div class="img_title">“碳中和”园区</div>
          <div class="img_content">
            思百达“碳中和”园区解决方案致力于园区实现“碳达峰”、“碳中和”提供综合解决思路、系统、产品及服务。通过为园区设立合理的用能目标，持续监控目标，为园区提供从供给侧到需求侧的节能方法和手段，打破以往园区一锤定音的实施方案，形成节能降碳的科学管理机制。
          </div>
        </div>
      </div>
    </div>

    <div class="content_center">
      <div class="item">
        <div class="content_title">
          <span
            v-for="(item1, index) in carbinContentArr.content_title"
            :key="index"
            >{{ item1 }}</span
          >
        </div>
        <div class="title_title">
          {{ carbinContentArr.title_title.title }}
        </div>
        <div class="title_content">
          {{ carbinContentArr.title_title.title_content }}
        </div>
        <div class="content_pic">
          <div
            class="pic"
            v-for="(item2, index) in carbinContentArr.pic"
            :key="index"
            v-lazy-container="{ selector: 'img' }"
          >
            <div class="pic_img">
              <img :data-src="item2.imgurl" alt="" />
            </div>
            <div class="pic_desc">
              <div class="desc_title">{{ item2.pic_title }}</div>
              <div class="desc_content">{{ item2.pic_content }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="content_title">
          <span
            v-for="(item1, index) in carbinContentArr1.content_title"
            :key="index"
            >{{ item1 }}</span
          >
        </div>
        <div class="title_title">
          {{ carbinContentArr1.title_title.title }}
        </div>
        <div class="content_pic">
          <div
            class="content1_pic"
            v-for="(item3, index) in carbinContentArr1.pic"
            :key="index"
            v-lazy-container="{ selector: 'img' }"
          >
            <img :data-src="item3.imgurl" alt="" />
            <div class="pic_desc" style="text-align: left">
              {{ item3.pic_content }}
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="content_title">
          <span
            v-for="(item4, index) in carbinContentArr2.content_title"
            :key="index"
            >{{ item4 }}</span
          >
        </div>
        <div class="title_title">
          {{ carbinContentArr2.title_title.title }}
        </div>
        <div class="content_pic">
          <div
            class="content2_pic"
            v-for="(item5, index) in carbinContentArr2.content"
            :key="index"
            :style="{ background: item5.bacColor }"
          >
            <div class="content2_pic_id">{{ item5.id }}</div>
            <div class="content2_pic_desc">
              <div class="content2_pic_title">{{ item5.title }}</div>
              <div
                class="content2_pic_content"
                v-for="(item6, index) in item5.content"
                :key="index"
              >
                {{ item6 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "carbinPark",
  data() {
    return {
      carbinContentArr: {
        content_title: ["政策背景"],
        title_title: {
          title: "“碳达峰”、“碳中和”是我国高质量发展的内在要求",
          title_content:
            "习近平主席在第七十五届联合国大会一般性辩论上提出：中国宣布将提高“国家自主贡献”力度，力争2030年前二氧化碳排放达到峰值，努力争取2060年前实现碳中和。碳达峰、碳中和是党中央经过深思熟虑作出的重大战略决策，只有纳入生态文明建设整体布局，才能推动经济社会绿色转型和系统性深刻变革。中国双碳目标意义重大、影响深远，但是面临排放总量大、减排时间紧、制约因素多等艰巨挑战，目标实现需统筹考虑能源安全、经济增长、社会民生、成本投入等诸多因素，对我国能源转型和经济高质量发展提出了更高要求。",
        },
        pic: [
          {
            imgurl: require("../assets/carbin2.png"),
            pic_title: "排放总量大",
            pic_content:
              "我国经济体量大、发展速度快、用能需求高，能源结构以煤为主，使得我国碳排放总量和强度“双高”",
          },
          {
            imgurl: require("../assets/carbin1.png"),
            pic_title: "减排时间紧",
            pic_content:
              "我国处于工业化和城镇化快速发展阶段，发展惯性大、路径依赖强，要用不到10年时间实现碳达峰，再用30年左右时间实现碳中和，时间紧、任务艰巨",
          },
          {
            imgurl: require("../assets/carbin3.png"),
            pic_title: "制约因素多",
            pic_content:
              "碳减排既是气候环境问题也是发展问题，涉及能源、经济、社会、环境等诸多方面",
          },
        ],
      },
      carbinContentArr1: {
        content_title: ["园区“双碳”"],
        title_title: {
          title: "园区是“双碳”战略实施落地的主战场",
        },
        pic: [
          {
            imgurl: require("../assets/carbin4.png"),
            pic_content:
              "中国电子信息产业发展研究院（赛迪研究院）在某报告中指出，工业是碳排放的重要领域，约占全部碳排放量的70%",
          },
          {
            imgurl: require("../assets/carbin5.png"),
            pic_content:
              "据国家统计局统计，规模以上的工业企业的产值在全国工业企业总产值中所占比重超过90%，而这类规模以上的工业企业的生产经营基本都发生在园区，所以说园区是双碳战略实施落地的主战场",
          },
        ],
      },
      carbinContentArr2: {
        content_title: ["基本框架"],
        title_title: {
          title: "“碳中和”园区建设基本框架",
        },
        content: [
          {
            id: 1,
            bacColor: "#C5E0B4",
            title: "形成低碳绿色产业体系",
            content: [
              "战略性新兴产业聚集",
              "企业低碳改造",
              "低碳技术创新供给",
              "碳中和金融",
            ],
          },
          {
            id: 2,
            bacColor: "#276FB1",
            title: "形成清洁能源利用体系",
            content: [
              "能效动态管控",
              "能源申报管理",
              "碳排放监测交易",
              "新型基础设施",
            ],
          },
          {
            id: 3,
            bacColor: "#8FAADC",
            title: "形成固废资源循环体系",
            content: ["可再生能源", "清洁能源", "常规能源"],
          },
          {
            id: 4,
            bacColor: "#ED8D25",

            title: "形成智慧园区管理体系",
            content: [
              "企业固废物循环利用",
              "工业废水重复利用",
              "可再生资源回收",
              "生活垃圾资源化处理",
              "污染物集中处置",
            ],
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
.title {
  font-size: 40px;
  color: #333;
}
.title > span:nth-of-type(2) {
  color: #0171bb;
}
.img_box {
  width: 100%;
  height: 400px;
  background-image: url(../assets/carbin_img.jpg);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #464646;
}
.img_center {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-weight: 400;
  color: #ffffff;
}
.img_title {
  width: 100%;
  margin-top: 102px;
  font-size: 60px;
}
.img_content {
  width: 75%;
  margin: 0 auto;
  font-size: 18px;
  line-height: 24px;
  margin-top: 26px;
  text-align: left;
}
.content {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.content_center {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 80px;
}
.item {
  width: 100%;
  font-size: 14px;
  color: #404040;
  margin-top: 106px;
  text-align: center;
}
.content_title {
  width: 300px;
  height: 47px;
  font-size: 40px;
  color: #333;
  line-height: 48px;
  margin: 0 auto;
}

.content_title > span:nth-of-type(2) {
  color: #f9ae3b;
}
.title_title {
  width: 600px;
  height: 24px;
  font-size: 24px;
  line-height: 21px;
  margin: 0 auto;
  margin-top: 32px;
}
.title_content {
  width: 90%;
  height: 100px;
  line-height: 22px;
  margin: 0 auto;
  margin-top: 20px;
  text-align: left;
  /* text-indent: 2em; */
}
.content_pic {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 35px;
}
.pic_desc {
  margin-top: 11px;
  padding: 0 15px;
}
.desc_title {
  width: 90px;
  height: 18px;
  font-size: 18px;
  font-weight: bold;
  line-height: 21px;
}
.desc_content {
  width: 370px;
  line-height: 21px;
  margin-top: 12px;
  text-align: left;
}
.content2_pic {
  width: 100%;
  margin-top: 41px;
  width: 280px;
  height: 200px;
  background: #c5e0b4;
  padding-top: 49px;
  text-align: left;
}
.content2_pic_id {
  float: left;
  margin-right: 30px;
  margin-left: 19px;
  width: 18px;
  height: 100%;
  font-size: 50px;
  margin-top: 7px;
  font-weight: bold;
  color: #ffffff;
  line-height: 13px;
}
.content2_pic_title {
  height: 19px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  line-height: 5px;
}
.content2_pic_content {
  margin-top: 3px;
  font-size: 14px;
  color: #ffffff;
  line-height: 21px;
}
.home_title {
  position: absolute;
  top: -358px;
  width: 999px;
  height: 25px;
  font-size: 18px;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
}
.home_title1 {
  font-size: 50px;
  line-height: 50px;
  font-weight: bold;
  margin-bottom: 30px;
}
@media (max-width: 1200px) {
  .content_center {
    width: 100%;
  }
  .home_title {
    width: 85%;
    font-size: 13px;
  }
  .content_center > div:nth-of-type(2) .content_pic {
    flex-direction: column;
  }
  .item {
    height: auto;
  }
  .content2_pic_title {
    line-height: 20px;
    margin-bottom: 20px;
  }
}
@media (max-width: 425px) {
  .content_center {
    padding-bottom: 30px;
  }
  .home_title1 {
    font-size: 40px;
  }
  .title_title {
    width: 100%;
    height: auto;
    line-height: inherit;
    font-size: 16px;
    padding: 0 10px;
  }
  .content2_pic_title {
    margin-bottom: 0;
    line-height: 0;
  }
  .title_content {
    width: 100%;
    height: auto;
    line-height: inherit;
    color: #8d8d8d;
    padding: 0 10px;
    text-align: left;
  }
  .content_title {
    font-size: 40px;
  }
  .desc_content {
    color: #8d8d8d;
  }
  .home_content {
    line-height: 22px;
    /* text-indent: 2em; */
  }
  .content_pic {
    flex-direction: column;
  }
  .pic_desc {
    margin: 13px 0;
  }
  .content1_pic img {
    width: 100%;
  }
  .content2_pic {
    width: 100%;
    margin: 0;
  }
    .img_center{
    width: 100%;
  }
  .img_title{
    font-weight: bold;
    font-size: 20px;
    margin-top: 40px;
  }
  .img_content{
    font-size: 12px;
    line-height: 18px;
    /* text-indent: 2em; */
    width: 90%;
    margin-top: 20px;
    text-align: left;
  }
  .img_box{
    height: 270px;
  }
  .item{
    margin-top: 50px;
    font-size: 12px;
  }
  .content_title{
    font-size: 30px;
  }
  .title_title{
    margin-top: 20px;
  }
  img{
    width: 100%;
  }
  .desc_title{
    font-size: 16px;
  }
  .desc_content{
    width: 100%;
  }
  .content2_pic_content{
    font-size: 12px;
  }
  .content2_pic_id{
    font-size: 35px;
    margin-top: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/carbinPark.vue